import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierList
} from '../../models/models';

@Component({
    selector: 'carrier-geocodelane-detail',
    templateUrl: './carrier-geocodelane-detail.component.html',
    standalone: false
})
export class CarrierGeocodeLaneDetail implements OnChanges {
    @Input() carrierID: number = 0;
    @Input() isBulkTender: boolean = false;
    @Input() carrier: CarrierList = {} as CarrierList;
    @Output() onRefresh = new EventEmitter<any>();

    public isLoading: boolean = false;
    public isExcludeNonRMISCertified: boolean = true;
    public rmisBadgeColor: string = "light";
    public rmisFirstLetter: string = "";
    //public carrier: SearchCarrier = {} as SearchCarrier;

    constructor(private cseService: CSEService, private utilService: UtilService) {
    }

    ngOnChanges() {
        //this.carrier.lastCarrierIncidentDate = new Date(this.carrier.lastCarrierIncidentDate);
        console.log("ngOnChanges", this.carrier, this.carrier.lastCarrierIncidentDate);
        //this.utilService.isLoading = true;
        //this.cseService.getSearchCarrierByCarrierID(this.carrierID).subscribe(result => {
        //    this.utilService.isLoading = false;
        //    this.carrier = result.resultCollection[0];
        //    this.carrier.rmisLastPotentialDate = new Date(this.carrier.rmisLastPotentialDate);
        //    //console.log("ngOnChanges", this.carrier);
        //});

        //this.getBadgeColor();
        //this.getRMISStatusFirstLetter();
    }

    //private getBadgeColor() {
    //    this.rmisBadgeColor = this.carrierList.rmisCertifiedColor;
    //    //console.log("getBadgeColor", this.rmisBadgeColor);
    //}

    //public getRMISStatusFirstLetter() {
    //    var firstLetter: string = "\u00A0";
    //    if (this.carrierList.rmisStatus != null && this.carrierList.rmisStatus.length > 0) {
    //        firstLetter = this.carrierList.rmisStatus.charAt(0);
    //    }
    //    this.rmisFirstLetter = firstLetter;
    //    //console.log("getRMISStatusFirstLetter", this.rmisFirstLetter);
    //}

    public getLastPotentialDate() {
        this.carrier.rmisLastPotentialDate = new Date(this.carrier.rmisLastPotentialDate);
        if (this.carrier.rmisLastPotentialDate > new Date('1/1/1970')) {
            return new Date(this.carrier.rmisLastPotentialDate).toDateString();
        }
        else {
            return "N/A";
        }
    }

    //public getLastCarrierIncidentDate() {
    //    this.carrier.lastCarrierIncidentDate = new Date(this.carrier.lastCarrierIncidentDate);
    //    console.log("getLastCarrierIncidentDate", this.carrier.lastCarrierIncidentDate);
    //    if (this.carrier.lastCarrierIncidentDate > new Date('1/1/1970')) {
    //        return new Date(this.carrier.lastCarrierIncidentDate).toDateString();
    //    }
    //    else {
    //        return "N/A";
    //    }
    //}

    public checkCarrierRMISQualification() {
        this.utilService.isLoading = true;
        this.cseService.checkCarrierRMISQualification(this.carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            //var carrier = result.resultCollection[0];
            this.onRefresh.emit(this.carrierID);
        });
    }
}
